import React from 'react'
import { motion } from 'framer-motion'
import { Phone, Clock, Mail, ExternalLink } from 'lucide-react'

const ContactCards = ({ openModal }) => {
  return (
    <div className="grid gap-8 md:grid-cols-2">
              {/* Call Us Card */}
              <motion.div
                whileHover={{ scale: 1.02 }}
                className="p-6 bg-white rounded-lg shadow-sm"
              >
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-pink-100 rounded-full">
                    <Phone className="w-6 h-6 text-pink-500" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold">Call Us</h3>
                    <div className="flex items-center space-x-2 text-gray-600">
                      <Clock className="w-4 h-4" />
                      <p>Everyday 8am-7pm</p>
                    </div>
                  </div>
                </div>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  className="flex justify-center items-center py-2 mt-4 space-x-2 w-full text-white bg-pink-500 rounded-lg"
                  onClick={() => openModal('phone')}
                >
                  <span>Call Support</span>
                  <ExternalLink className="w-4 h-4" />
                </motion.button>
              </motion.div>

              {/* Email Card */}
              <motion.div
                whileHover={{ scale: 1.02 }}
                className="p-6 bg-white rounded-lg shadow-sm"
              >
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-blue-100 rounded-full">
                    <Mail className="w-6 h-6 text-blue-500" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold">Email</h3>
                    <div className="flex items-center space-x-2 text-gray-600">
                      <Clock className="w-4 h-4" />
                      <p>Estimated reply time is 1hr</p>
                    </div>
                  </div>
                </div>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  className="flex justify-center items-center py-2 mt-4 space-x-2 w-full text-white bg-blue-500 rounded-lg"
                  onClick={() => openModal('email')}
                >
                  <span>Send Email</span>
                  <ExternalLink className="w-4 h-4" />
                </motion.button>
              </motion.div>
            </div>
  )
}

export default ContactCards
